import {useCustomSegments} from './useCustomSegments';
import { formHelpers } from '../utils/helpers';

const remoteIdProp = 'remote_id';

export const useAccountingCustomSegments = ({levelsPropertyName = 'level'} = {}) => {
  const customSegments = useCustomSegments({ levelsPropertyName });

  return customSegments
    .filter(s => s?.setup?.active)
    .map(s => {
      const internalId = s?.setup?.internal_id;
      const title = s?.setup?.name || 'Unnamed';
      const levels = s?.setup?.[levelsPropertyName] || [];
      return {
        dataIndex: internalId,
        levels,
        name: internalId,
        options: formHelpers.formatSelectOptions({ data: s?.values || [], valueProp: remoteIdProp }),
        title,
      }
    });
};
